import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-page-skeleton',
  templateUrl: './payment-page-skeleton.component.html',
})
export class PaymentPageSkeletonComponent {
  public skeletonRows = [1, 2, 3, 4];
  public skeletonGroups = [1, 2];
}
